<template>
  <tbody class="line-item">
    <tr class="line-item-details">
      <td>
        <div ref="test"></div>
        <v-text-field
          type="number"
          ref="quantityText"
          v-if="quantity >= limit || editMode"
          label="Qty"
          v-model.number="quantity"
          hide-details
        ></v-text-field>
        <v-select v-else v-model="quantity" :items="items" label="Qty">
          <v-btn text slot="append-item" @click="clickTenPlus()">10+</v-btn>
        </v-select>
      </td>

      <td>
        <img class="line-item-image" :src="item.image.smallUrl" />
      </td>
      <td>
        <div>
          <p style="margin: 0px; font-size: 18px;">
            <b v-if="item.product">{{item.product.name}}</b>
            <span
              v-if="item.product && item.product.collection"
              class="ml-1"
              style="color: gray;"
            >/ {{item.product.collection}}</span>
          </p>
          <p style="margin: 0px; font-size: 12px; color: gray;">{{item.sku}}</p>
        </div>
      </td>
      <td v-for="column in config.cartColumns" :key="column.id">
        <div v-if="item.product">{{item.product.cells[column.id].display}}</div>
      </td>
      <td>
        <v-progress-circular v-if="item.loading" indeterminate></v-progress-circular>
        <div v-else>{{item.effectivePrice}}</div>
      </td>
      <td>
        <v-btn color="primary" @click="clickBack()">Back</v-btn>
      </td>
      <td>
        <v-btn
          v-if="item.product && item.product.configurable"
          color="primary"
          @click="clickConfig()"
        >Config</v-btn>
      </td>
      <td>
        <v-btn color="error" @click="clickDelete()" :loading="deleting" :disabled="deleting">Delete</v-btn>
      </td>
    </tr>
    <tr>
      <td :colspan="colspan">
        <table class="option-table">
          <thead>
            <th class="key-column"></th>
            <th class="value-column"></th>
          </thead>
          <tr class="option-row" v-for="option in item.options" :key="option.Name">
            <td class="key">{{option.Name}}</td>
            <td class="value">{{!option.SelectedValue ? "Not Selected" : option.SelectedValue.Name}}</td>
          </tr>
        </table>
      </td>
    </tr>
    <tr class="line-item-notes">
      <td :colspan="colspan">
        <v-text-field label="Notes" v-model="notes" hide-details></v-text-field>
      </td>
    </tr>
  </tbody>
</template>

<script>
import _ from "lodash";

export default {
  props: {
    item: Object
  },
  data: () => {
    var limit = 10;
    return {
      limit: limit,
      loading: false,
      deleting: false,
      items: [...Array(limit).keys()],
      editMode: false
    };
  },
  computed: {
    notes: {
      get: function() {
        return this.item.notes;
      },
      set: _.debounce(function(value) {
        this.$store.dispatch("setItemNotes2", {
          item: this.item,
          notes: value
        });
      }, 1000)
    },
    quantity: {
      get: function() {
        return this.item.quantity;
      },
      set: _.debounce(function(value) {
        this.$store.dispatch("setItemQuantity2", {
          item: this.item,
          quantity: value
        });
      }, 1000)
    },
    colspan: function() {
      return 7 + this.config.cartColumns.length;
    },
    config: function() {
      return this.$store.state.config;
    },
    slideshow: function() {
      return this.$store.state.slideshow;
    },
    tree: function() {
      return this.$store.state.tree;
    }
  },
  methods: {
    clickBack: function() {
      var theGroup = this.tree.groups.find(group =>
        group.products.some(product => product.sku == this.item.product.sku)
      );

      if (!theGroup) {
        return;
      }

      this.$store.commit("clearPath");
      this.$router.push(
        `/Manufacturers/${this.$store.state.manufacturerId}/Avenue/Groups/${theGroup.pageNumber}`
      );
    },
    clickDelete: async function() {
      try {
        this.deleting = true;
        await this.$store.dispatch("deleteItem2", this.item);
      } catch (error) {
        alert(error);
      } finally {
        this.deleting = false;
      }
    },
    clickConfig: function() {
      this.$router.push(
        `/Manufacturers/${this.$store.state.manufacturerId}/Avenue/Config/${this.item.id}`
      );
    },
    clickTenPlus: function() {
      this.editMode = true;
      this.$nextTick(() => this.$refs.quantityText.focus());
    }
  },
  watch: {
    quantity: function(value) {
      if (value < this.limit) {
        this.editMode = false;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.line-item {
  background-color: white;
}

.option-table {
  width: 100%;
  border-collapse: collapse;
  table-layout: fixed;

  .option-row {
    &:not(:last-child) {
      border-bottom: 1px solid rgb(200, 200, 200);
    }

    &:nth-child(even) {
      background-color: rgb(240, 240, 240);
    }

    td {
      padding: 5px;
    }
    .key {
      font-weight: bold;
      text-align: right;
      width: auto;
    }
    .value {
      text-align: left;
    }
  }
}
</style>